import Service, { service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import dateSort from 'scaleflow/utils/dateSort';

export default class RoadmapService extends Service {
  @service store;
  @service router;
  @tracked roadmap;
  @tracked id;

  async setup() {
    const roadmaps = await this.store.findAll('roadmap', {
      reload: true,
      include: 'bon',
    });
    this.roadmap = roadmaps[roadmaps.length - 1];
    this.id = this.roadmap.id;
  }

  get selected() {
    return this.roadmap;
  }
  get initiatives() {
    return this.roadmap?.initiatives?.content ?? [];
  }

  get investmentScenario() {
    return this.roadmap?.get('investment-scenario');
  }

  get scenario() {
    return this.investmentScenario;
  }

  get not_set() {
    return this.roadmap == undefined;
  }

  @action
  async isCurrentRoadmap(roadmap) {
    return this.roadmap?.id == roadmap?.id;
  }

  @action
  async setRoadmap(event) {
    await this.setId(event.target.value);
  }

  @action
  async setId(value) {
    this.id = value;
    this.roadmap = this.store.peekRecord('roadmap', value);
  }

  async loadRoadmapInitiatives() {
    try {
      const initiative_ids = this.roadmap?.hasMany('initiatives')?.ids() ?? [];
      const promises = [];
      for (let i = 0; i < initiative_ids.length; i++) {
        promises.push(
          this.store.findRecord('initiative', initiative_ids[i], {
            include: 'workstream',
          }),
        );
      }
      await Promise.allSettled(promises);
    } catch (err) {
      console.debug(err);
    }
  }

  get roadmaps() {
    return this.store.peekAll('roadmap');
  }

  get roadmaps_sorted_by_start_date() {
    return this.roadmaps.toSorted((a, b) =>
      dateSort(b.start_date, a.start_date),
    );
  }
}
